import { useId } from "react";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { money } from "@/lib/landingSim";

export const GrowthChart = ({ sim, height = 220 }) => {
  const gid = `gv${useId().replace(/:/g, "")}`;
  return (
  <div style={{ height }} data-testid="growth-chart">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={sim.months} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#2563eb" stopOpacity={0.35} /><stop offset="100%" stopColor="#2563eb" stopOpacity={0} /></linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
        <XAxis dataKey="month" tickFormatter={m => `M${m}`} fontSize={11} />
        <YAxis fontSize={11} width={48} />
        <Tooltip formatter={(v, k) => (k === "revenue" ? money(v) : v)} labelFormatter={m => `Month ${m}`} />
        <Area type="monotone" dataKey="visits" stroke="#2563eb" fill={`url(#${gid})`} strokeWidth={2} name="visits" />
        <Area type="monotone" dataKey="leads" stroke="#16a34a" fill="none" strokeWidth={2} name="leads" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
  );
};

export const SimTotals = ({ sim, cost }) => (
  <div className="grid grid-cols-2 md:grid-cols-5 gap-2" data-testid="sim-totals">
    {[["12-mo visits", Math.round(sim.totals.visits).toLocaleString()], ["Leads", sim.totals.leads], ["New customers", sim.totals.customers],
      ["Revenue", money(sim.totals.revenue)], ["Pays back", sim.payback_month ? `Month ${sim.payback_month}` : cost ? "> 12 mo" : "—"]].map(([l, v]) => (
      <div key={l} className="bg-slate-50 border border-slate-200 rounded-lg p-2.5">
        <p className="text-[10px] uppercase font-bold text-slate-400">{l}</p>
        <p className="font-black text-slate-900">{v}</p>
      </div>
    ))}
  </div>
);
